import { createContext, useContext, useState, ReactNode  } from 'react';
const selectedContactContextInfo = createContext<any>({});


export const SelectedContactProvider = ({ children }: { children: ReactNode })=>{
    const [selectInputValue, setSelectInputValue] = useState<string>("");
    return(
        <selectedContactContextInfo.Provider value={{selectInputValue: selectInputValue, setSelectInputValue: setSelectInputValue}}>
            {children}
        </selectedContactContextInfo.Provider>
    )
}

export const SelectedContactConsumer = ()=>{
    return useContext(selectedContactContextInfo);
}
